
import {
  IconQuality,
  RevButton,
  RevDivider,
  RevRating,
} from '@backmarket/design-system'

import { insertIf } from '@core/helpers'
import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { fetchReviewsSummaryByProduct } from '@http/endpoints'
import { TRACKING_ZONE } from '@internal-reviews/components/Page/constants'
import logger from '@logger'
import RateFilter from '@reviews/Internal/components/RateFilter'
import ReviewsLegalModal from '@reviews/Internal/components/ReviewsLegalModal'
import UserComment from '@reviews/Internal/components/UserComment'
import { trackClick, trackReviewBlockImpression } from '@tracking/events'

import translations from './ReviewsBlock.translations'

export default {
  components: {
    IconQuality,
    RateFilter,
    RevRating,
    RevButton,
    RevDivider,
    UserComment,
    ReviewsLegalModal,
  },
  props: {
    averageRate: {
      type: Number,
      required: true,
    },
    reviewsCount: {
      type: Number,
      required: true,
    },
    reviews: {
      type: Array,
      default: () => [],
    },
    link: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
    // [COM-263] TODO to remove when AB test is over
    isReviewTranslationEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rateDistribution: [],
    }
  },
  computed: {
    translations: () => translations,
    shouldDisplayCta() {
      return this.reviewsCount > 1
    },
    reviewTrackingInfo() {
      return {
        ...this.trackingInfo,
        averageRate: this.averageRate,
        pageType: this.$route.name,
      }
    },
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  async mounted() {
    this.watchReviewInViewport()

    const [{ payload: rateDistribution }] = await Promise.all([
      await this.$store
        .dispatch('http/request', {
          request: fetchReviewsSummaryByProduct,
          pathParams: { productId: this.productId },
          // [COM-263] TODO to remove when AB test is over
          ...insertIf(this.isReviewTranslationEnabled, {
            queryParams: { withReviewTranslation: true },
          }),
        })
        .catch((error) => {
          logger.error(error)

          return { payload: {} }
        }),
    ])

    this.rateDistribution = rateDistribution.statsInfo || []
  },
  methods: {
    watchReviewInViewport() {
      this.unobserve = createObserver(this.$el, () => {
        trackReviewBlockImpression(this.reviewTrackingInfo)
      })
    },
    displayDivider(index) {
      return index < this.reviews.length - 1
    },
    trackReviews() {
      trackClick({
        zone: TRACKING_ZONE,
        name: 'see_all_reviews',
        pageType: this.$route.name,
      })
    },
  },
}
